var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'demo__flex demo__flex-middle': _vm.mode === 'horizontal',
  }},[(!_vm.isFullNameEmpty)?_c('div',[_c('div',{class:{
        ['demo__font--' + _vm.css.author.font.size]: true,
        ['demo__weight--' + _vm.css.author.font.weight]: true,
      }},[_vm._v(" "+_vm._s(_vm.fullname)+" ")]),(_vm.author.company)?_c('div',{class:{
        ['demo__font--' + _vm.css.company.font.size]: true,
        ['demo__weight--' + _vm.css.company.font.weight]: true,
      }},[_vm._v(" "+_vm._s(_vm.author.company)+" ")]):_vm._e()]):(_vm.css.author)?_c('div',{class:{
      ['demo__font--' + _vm.css.author.font.size]: true,
      ['demo__weight--' + _vm.css.author.font.weight]: true,
    }},[_vm._v(" "+_vm._s(_vm.$t("As Anon"))+" ")]):_vm._e(),_c('div',{class:{
      'demo__margin-top--30': _vm.mode === 'vertical',
      'demo__flex-right': _vm.mode === 'horizontal',
      'demo__flex demo__flex-middle': !_vm.isMobile,
    }},[_c('div',{staticClass:"demo__flex demo__flex-middle"},_vm._l((_vm.reactions),function(reaction,index){return _c('AuthLockBlock',{key:reaction.title,class:{
          ['demo__margin-left--' + _vm.css.reactions.margin]: index !== 0,
        },attrs:{"ym_location":reaction.ymLocation}},[_c('div',{staticClass:"demo__flex demo__flex-middle",on:{"click":function($event){return reaction.click()}}},[_c('i',{class:{
              ['demo__font--' + _vm.css.reactions.icon.size]: true,
              ['demo__margin-right--' + _vm.css.reactions.icon.margin]: true,
              [reaction.icon]: true,
              'animated bounceIn': reaction.animate,
            }}),_c('div',{class:{
              ['demo__font--' + _vm.css.reactions.text.size]: true,
              ['demo__weight--' + _vm.css.reactions.text.weight]: true,
            }},[_vm._v(" "+_vm._s(_vm.object[reaction.field])+" ")])])])}),1),(_vm.buttons && _vm.buttons.length)?_c('div',{staticClass:"demo__flex-right",class:{
        'demo__flex demo__flex-column demo__margin-top--20 111': _vm.isMobile,
      }},_vm._l((_vm.buttons),function(button,index){return _c('a-tooltip',{key:button.title,attrs:{"visible":button.showTippy,"placement":"bottom"}},[_c('div',{staticClass:"p-all share-tooltip",attrs:{"slot":"title"},slot:"title"},[_vm._v(" "+_vm._s(_vm.$t(button.tippy))+" ")]),_c('a-button',{staticClass:"demo__button",class:{
            'demo__margin-right--20': index !== _vm.buttons.length - 1,
            ['demo__button--' + button.bg]: true,
          },style:({
            width: _vm.isMobile
              ? '100% !important'
              : button.width
              ? button.width + 'px !important'
              : 'auto',
            marginTop: _vm.isMobile ? '10px' : 'unset',
          }),on:{"click":function($event){button.callback ? button.callback() : false}}},[_c('i',{staticClass:"demo__margin-right--9",class:{
              [button.icon]: true,
            }}),_vm._v(" "+_vm._s(button.title)+" ")])],1)}),1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }